import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-900 text-white py-4 px-4 text-center text-xs" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <p data-id="element-189">WOMEN'S HEALTH | Advertorial</p>
      </div>
    </footer>;
};